import {NIF} from '../reducers/NifReducer';

export const NifDispatch = (value) => {
    return{
        type: NIF,
        payload: value
    }
}